import { render, staticRenderFns } from "./ImportSie.vue?vue&type=template&id=0c74e6be&scoped=true&"
import script from "./ImportSie.vue?vue&type=script&lang=ts&"
export * from "./ImportSie.vue?vue&type=script&lang=ts&"
import style0 from "./ImportSie.vue?vue&type=style&index=0&id=0c74e6be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74e6be",
  null
  
)

export default component.exports